export const meetUsEvents = [
  {
    name: "World Wholesale Congress",
    icon: "ri-global-line",
    venue: "WWC",
    dates: "16–18 Sep 2026",
    city: "Madrid, Spain",
    desc: "The flagship gathering for international wholesale voice. Meet our carrier-relations and engineering leadership, see live route-quality dashboards, and negotiate direct interconnects in person.",
  },
  {
    name: "Capacity Middle East",
    icon: "ri-building-2-line",
    venue: "Capacity Media",
    dates: "9–11 February 2027",
    city: "Dubai, UAE",
    desc: "The premier meeting point for Middle East, Africa, and Asia connectivity. Our team will be on hand to discuss MENA and APAC route quality, DID origination, and new transit partnerships.",
  },
];

export const complianceItems = [
  {
    title: "United States",
    icon: "ri-flag-line",
    body: "Registered with the FCC as an international telecommunications carrier (ITC). Section 214 authorization. Compliant with STIR/SHAKEN caller ID authentication framework. CALEA-capable infrastructure for lawful intercept. Annual CPNI certification filed.",
    license: "FCC ITC 214",
  },
  {
    title: "European Union",
    icon: "ri-flag-line",
    body: "GDPR-compliant data processing and retention. Registered data controller in Ireland. CDR and personal data retained per EDPB guidelines. Right-to-erasure workflows implemented. Sub-processor agreements with all transit partners.",
    license: "GDPR registered",
  },
  {
    title: "United Kingdom",
    icon: "ri-flag-line",
    body: "Registered with Ofcom under the General Conditions of Entitlement. UK GDPR compliant post-Brexit. CDR retention aligned with Data Retention and Acquisition Regulations. Lawful intercept capability maintained.",
    license: "Ofcom registered",
  },
  {
    title: "Data Security & Encryption",
    icon: "ri-lock-2-line",
    body: "All signaling encrypted via TLS 1.3. Media encrypted via SRTP with AES-256-GCM by default. CDR storage encrypted at rest (AES-256). Access controlled via RBAC with MFA. Annual penetration testing by independent security firm. SOC 2 Type II audit in progress — expected completion Q4 2026.",
    license: "SOC 2 (in progress)",
  },
  {
    title: "Anti-Fraud & KYC",
    icon: "ri-shield-check-line",
    body: "Know Your Customer (KYC) verification required for all new accounts. Transaction monitoring for unusual traffic patterns. Automated CLI validation and destination velocity detection. Revenue-share fraud blocking at the network edge. Suspicious Activity Reports (SARs) filed per jurisdictional requirements.",
    license: "Internal compliance",
  },
  {
    title: "Business Continuity",
    icon: "ri-archive-line",
    body: "BCP/DR plan tested quarterly. RPO: 15 minutes. RTO: under 1 hour. All PoPs independently powered and cooled. Diverse fiber paths at each carrier hotel. Emergency failover tested during every maintenance window. Incident response team on 24/7 rotation.",
    license: "BCP certified",
  },
];

export const companyStats = [
  { value: "2008", label: "Founded" },
  { value: "30+", label: "Team members" },
  { value: "Las Vegas", label: "Headquarters" },
  { value: "700+", label: "Active clients" },
  { value: "4", label: "Global PoPs" },
  { value: "60M+", label: "Annual minutes" },
];